import { enumToOption } from '@/utils'

// 应用名称
export enum applicationType {
  SaaS管理平台 = 1,
  SaaS运营平台,
  企业版小程序,
  车主版小程序,
  司机版小程序
}
//   响应状态名称
export enum responseStateMsg {
  成功 = 1,
  失败,
}

export const applicationTypeOption = enumToOption(applicationType)
export const responseStateMsgOption = enumToOption(responseStateMsg)

export const getTableConfig = () => {
  // table 通用属性
  const common = {
    // table 有多选时设置
    isSelection: false,
    // table loading
    loading: false,
    // table 是否为斑马纹
    stripe: true,
    isIndex: false,
    // table 索引 label
    indexLabel: '序号',
    // table 的尺寸 medium / small / mini
    size: 'small',
    // table 数据
    data: []
  }

  // table 分页
  const pagination = {
    // 是否展示分页
    isShow: true,
    // 总条数
    total: 0,
    // 每页显示条目个数
    pageSize: 20,
    // 当前页数
    currentPage: 1,
    // 每页显示个数选择器的选项设置
    pageSizes: [10, 20, 40, 80, 100]
  }

  // table 列数据
  const column = [
    {
      key: 'applicationTypeName',
      label: '应用类型',
      width: '80'
    },
    {
      key: 'operator',
      label: '操作人',
      width: '80'
    },
    {
      key: 'operatorTypeName',
      label: '帐号类型',
      width: '80'
    },
    {
      key: 'companyName',
      label: '所属企业',
      width: '100',
      formatter: (row, col, val) => val || '-'
    },
    {
      key: 'operatorTime',
      label: '操作时间',
      width: '120'
    },
    {
      key: 'ip',
      label: 'IP',
      width: '60'
    },
    {
      key: 'requestUri',
      label: '接口地址',
      width: '180'
    },
    {
      key: 'requestBody',
      label: '请求参数',
      width: '180'
    },
    {
      key: 'responseStateMsgName',
      label: '响应状态',
      width: '60'
    },
    {
      key: 'action',
      label: '操作',
      width: '110',
      fixed: 'right',
      slot: 'action'
    }
  ]

  return {
    ...common,
    pagination,
    column
  }
}
// 搜索配置
export const inputList = (remoteData1: any) => [
  {
    type: 'datePicker',
    label: '操作时间',
    key: 'Time',
    placeholder: '请选择',
    labelWidth: 100,
    inputWidth: 410,
    format: 'YYYY-MM-DD HH:mm',
    // 操作时间默认当前时间回推 1 小时 ~ 次日 0 点
    value: [new Date(new Date().getTime() - 3600 * 1000), new Date(new Date().setHours(0, 0, 0, 0) + 24 * 60 * 60 * 1000)],
    // 设置禁用状态，参数为当前日期，要求返回 Boolean
    // disabledDate: (time) => {
    //   return time.getTime() > Date.now()
    // },
    // 日期类型 year/month/date/dates/ week/datetime/datetimerange/ daterange/monthrange
    dateType: 'datetimerange',
    formatList: ['YYYY-MM-DD HH:mm:00', 'YYYY-MM-DD HH:mm:00'], // 开始，结束时间格式
    // keyList: ['startTime', 'endTime'], // 开始，结束时间字段
    // 开启日期范围后生效
    unlinkPanels: false,
    rangeSeparator: '-',
    startPlaceholder: '开始日期',
    endPlaceholder: '结束日期',
    rules: {
      // 默认 date 开启范围 array
      required: true,
      message: '必填',
      type: 'array'
    }
  },
  {
    type: 'select',
    label: '应用类型',
    key: 'applicationType',
    placeholder: '请选择',
    labelWidth: 100,
    inputWidth: 200,
    value: 2,
    options: applicationTypeOption
  },

  {
    type: 'select',
    label: '企业名称',
    key: 'companyUuid',
    placeholder: '请输入',
    labelWidth: 100,
    inputWidth: 340,
    maxlength: 50,
    options: remoteData1.options,
    isLoading: remoteData1.isLoading,
    isRemote: true,
    isMultiple: false,
    isFilterable: true,
    isCollapseTags: false,
    remoteMethod: remoteData1.remoteMethod,
    rules: {
    }
  },
  {
    type: 'input',
    label: '请求接口',
    key: 'requestUri',
    placeholder: '请输入',
    labelWidth: 100,
    inputWidth: 200
  },
  {
    type: 'input',
    label: '请求参数',
    key: 'requestBody',
    placeholder: '请输入',
    labelWidth: 100,
    inputWidth: 200
  },
  {
    type: 'select',
    label: '响应状态',
    key: 'responseStateMsg',
    placeholder: '请选择',
    labelWidth: 100,
    inputWidth: 200,
    options: responseStateMsgOption
  },
]
